import * as React from 'react';

import { HeadingSection, Page } from 'src/components/sellerFlow/complete';
import imgixUrl from 'src/helpers/imgixUrl';
import layoutWrapper from 'src/hocs/layoutWrapper';

const FlowCompleteRequestListingAgentOffer: React.FC = () => {
  return (
    <Page>
      <HeadingSection
        description={
          'Thanks for your interest in Opendoor. We sent an email asking them to request a cash offer on your behalf.'
        }
        heading="We emailed your agent"
        imgUrl={imgixUrl('afa8b395f9844913b9fc5c3a933f789d.png')}
      />
    </Page>
  );
};

export default layoutWrapper(FlowCompleteRequestListingAgentOffer);
